<template>
    <div v-show="deleteIsOn" name="modal">
        <div class="modal modal-mask small-modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">

                    <!-- Header -->

                    <div class="modal-header">
                        <h3 class="modal-title">Delete Contact Request</h3>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="close">
                            <span aria-hidden="true" class="icon-x"></span>
                        </button>
                    </div>

                    <!-- Body -->

                    <div class="modal-body">
                        <div class="notifications-container">
                            <FormNotification :message="notification"/>
                            <FormNotification is-error :message="error"/>
                        </div>
                        <div class="modal-question" v-show="!deleteRequestSent">
                            <p>Are you sure you want to delete this contact?</p>
                            <div class="buttons-container">
                                <button type="button" class="btn-large btn-red float-right" :disabled="deleteInProgress" @click.prevent="requestDelete">
                                    <span v-if="!deleteInProgress">Delete</span>
                                    <span v-if="deleteInProgress" class="spinner-border mt-0"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { AccountService } from "@/services/account-service";
    import { PageMessage } from "@/models/page-message";
    import FormNotification from "@/components/Login/FormNotification";

    export default {
        name: "RequestDelete",

        props: [
            'deleteIsOn'
        ],

        components: {
            FormNotification
        },

        data(){
            return{
                deleteRequestSent: false,
                deleteInProgress: false,
                error: new PageMessage(),
                notification: new PageMessage(),
            }
        },

         created() {
            this.accountService = new AccountService(this.$api, this.$store);
        },

        methods: {
            async requestDelete(){
                this.deleteInProgress = true;
                this.error.reset();
                this.notification.reset();

                try {

                    var response = await this.accountService.deactivateAccount();

                    var msg = '';
                    if(response == 'Deactivated'){
                        msg = 'Your request has been successfully sent.'
                    }

                    this.notification.set(msg);
                    this.deleteInProgress = false;
                    this.deleteRequestSent = true;
                    
                } catch (error) {
                    this.error.setError(error.data.title);
                }
            }, 

            close(){
                this.error.reset();
                this.notification.reset();
                this.$emit('closeRequestDeleteDialog');
                this.deleteRequestSent = false;
                this.deleteInProgress = false;
            }
        }
    };
</script>